import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaInstagram,
} from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io5";
import "../../styles/Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Contact */}
        <div className="footer-section">
          <h2>Contact Us</h2>
          <p>
            <FaPhoneAlt aria-hidden="true" /> +91 9620875447
          </p>
          <p>
            <FaEnvelope aria-hidden="true" /> priya.dharshinie123@gmail.com
          </p>
          <p>
            <FaMapMarkerAlt aria-hidden="true" />
            #4, 4th Cross, Sunderalingeshwara Temple Road, Chikkasandra,
            Bengaluru, Karnataka 560057
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h2>Quick Links</h2>
          <ul className="footer-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/admission">Admissions</Link>
            </li>
            <li>
              <Link to="/gallery">Gallery</Link>
            </li>
          </ul>
        </div>

        {/* Social */}
        <div className="footer-section">
          <h2>Follow Us</h2>
          <div className="footer-social">
            <a
              href="https://www.instagram.com/priyadharshinie_public_school_"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Priyadharshinie Public School on Instagram"
            >
              <FaInstagram aria-hidden="true" />
            </a>

            <a
              href="https://www.facebook.com/share/17UiJhG6i1/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Priyadharshinie Public School on Facebook"
            >
              <FaFacebook aria-hidden="true" />
            </a>

            <a
              href="https://wa.me/919620875447?text=I%20want%20to%20know%20more%20about%20the%20school"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chat with Priyadharshinie Public School on WhatsApp"
            >
              <IoLogoWhatsapp aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Priyadharshinie Public School. All rights
        reserved.
      </div>
    </footer>
  );
}
